import React from 'react';
import PropTypes from 'prop-types';
import { useDividerGradient } from '../gradient-utils';

export function Spill({
  className,
  depth = 50,
  position = 50,
  fadeOpacity,
  fadeDirection,
  softness,
  style
}) {
  const { defs, fill, mask } = useDividerGradient({ fadeOpacity, fadeDirection, softness });

  const scale = depth / 50;
  const mid = 70;

  // Focal point position: 0=left, 50=center, 100=right
  const focalX = (position / 100) * 1200;

  // y with envelope: points closer to focal get boosted (deeper dips)
  const y = (base, x) => {
    const dist = Math.abs(x - focalX);
    const proximity = 1 - Math.min(dist / 600, 1);
    const boost = proximity * 25;
    const adjusted = base < mid ? base - boost : base;
    return mid + (adjusted - mid) * scale;
  };

  const TOP_MARGIN = 10;
  const minY = 70 - 65 * scale - TOP_MARGIN;
  const pathBottom = 120;
  const viewHeight = pathBottom - minY;
  const viewBox = `0 ${minY} 1200 ${viewHeight}`;

  return (
    <svg
      className={ className }
      style={ style }
      viewBox={ viewBox }
      preserveAspectRatio='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      { defs }
      <path
        d={ `M0,${y(80, 0)}
           C50,${y(80, 50)} 100,${y(40, 100)} 200,${y(50, 200)}
           C300,${y(60, 300)} 350,${y(90, 350)} 450,${y(85, 450)}
           C550,${y(80, 550)} 600,${y(30, 600)} 700,${y(40, 700)}
           C800,${y(50, 800)} 850,${y(100, 850)} 950,${y(95, 950)}
           C1050,${y(90, 1050)} 1100,${y(50, 1100)} 1200,${y(60, 1200)}
           L1200,120 L0,120 Z` }
        fill={ fill }
        mask={ mask }
      />
    </svg>
  );
}

Spill.propTypes = {
  className: PropTypes.string,
  depth: PropTypes.number,
  position: PropTypes.number,
  fadeOpacity: PropTypes.number,
  fadeDirection: PropTypes.oneOf(['down', 'up', 'left', 'right']),
  softness: PropTypes.number
};
